// Copyright (c) 2021 Deere & Company

export const isEntitled = (entitlements, rule) => {

    const match = entitlements.filter(entitlement => entitlement.key === rule && entitlement.value === 'true');

    return match.length;

};



// WEBPACK FOOTER //
// ./src/shared/services/entitlements.js